import React, {Component} from 'react';
import styled from 'styled-components';
import {Typography, Layout, Row, Col} from 'antd';

const {Header, Content} = Layout;
const {Title} = Typography;

const JobTab = styled.div`
  background: #000;
  width: 100%;
  height: 10px;
  border-radius: 2em;
  border: 2px solid #333;
`;
const ColorTab = styled.div`
  background-image: linear-gradient(to right, #e22784, #fc673d);
  width: 100%;
  height: 10px;
  border-radius: 2em;
`;

class JobsPage extends Component {
  constructor() {
    super();
  }

  componentDidMount() {}

  render() {
    return (
      <Layout style={{width: '100vw', height: '100vh', background: 'black'}}>
        <Content style={{paddingTop: '10em', width: '80%', margin: '0 auto'}}>
          <Row>
            <Col>
              <div>
                <JobTab />
                <Title style={{padding: 20, fontSize: '1em'}}>
                  FULL-TIME
                </Title>
              </div>
            </Col>
            <Col>
              <div style={{background: '#333'}}>
                <ColorTab />
                <Title style={{padding: 20, fontSize: '1em'}}>
                  PART-TIME
                </Title>
              </div>
            </Col>
            <Col>
              <div>
                <JobTab />
                <Title style={{padding: 20, fontSize: '1em'}}>
                  INTERNSHIP
                </Title>
              </div>
            </Col>
            <Col>
              <div>
                <JobTab />
                <Title style={{padding: 20, fontSize: '1em'}}>
                  GIGS
                </Title>
              </div>
            </Col>
          </Row>
        </Content>
      </Layout>
    );
  }
}

export default JobsPage;
